// Joining translated sentences into one line (#5776). English sentences take a
// space between them; a Chinese sentence already ends in its own full-width
// terminator (`。`, or a halfwidth `?` / `!` straight after a CJK character, the
// house style), and a space after it reads as a typo. The separator is decided
// by the sentence before it, so mixed lines (a zh sentence followed by the
// server's English detail) come out right too.

const CJK_TERMINAL = /(?:[。！？]|[\u3400-\u9fff][?!])$/;

/** One line from several sentences: a space between them, none after a CJK terminator. */
export function joinSentences(parts: readonly string[]): string {
  return parts.reduce(
    (line, part) => (line === '' ? part : `${line}${CJK_TERMINAL.test(line) ? '' : ' '}${part}`),
    '',
  );
}
